export const KLARNA_CONTAINER_OFFSET = 60;
